import { render, staticRenderFns } from "./TestConfig.vue?vue&type=template&id=a84dfd7e&"
import script from "./TestConfig.vue?vue&type=script&lang=js&"
export * from "./TestConfig.vue?vue&type=script&lang=js&"
import style0 from "./TestConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports